import { useQuery } from '@tanstack/react-query'
import { FETCH_POSTS_KEY, fetchPosts } from '../api/posts'
import {
  FETCH_FEATURED_POSTS_SLUGS,
  FETCH_HOME_TOPICS_KEY,
  FETCH_TOPIC_NAVIGATION_KEY,
  fetchFeaturedPostsSlugs,
  fetchHomeTopics,
  fetchTopicNavigation,
} from '../api/collections'
import { FETCH_MINIMAL_VIEW, fetchMinimalView } from '../lib/minimalView'

interface PostData {
  [slug: string]: Post
}
interface TopicNavigationData {
  items: Topic[]
  name: string
  slug: string
}

export const useFeaturedPosts = () => {
  const posts = usePosts()

  const featuredPostsQuery = useQuery({
    enabled: !!posts,
    queryKey: [FETCH_FEATURED_POSTS_SLUGS],
    queryFn: fetchFeaturedPostsSlugs,
    staleTime: 3600 * 1000,
  })

  return featuredPostsQuery.data?.itemIds.map(
    (slug: string) => posts[slug]
  ) as Post[]
}

export const useHomeTopics = () => {
  const homeTopicsQuery = useQuery({
    queryKey: [FETCH_HOME_TOPICS_KEY],
    queryFn: fetchHomeTopics,
    staleTime: 3600 * 1000,
  })

  return homeTopicsQuery.data as TopicNavigationData
}

export const useMinimalView = () => {
  const minimalViewQuery = useQuery({
    queryKey: [FETCH_MINIMAL_VIEW],
    queryFn: fetchMinimalView,
  })

  return minimalViewQuery.data as boolean
}

export const usePosts = () => {
  const postsQuery = useQuery({
    queryKey: [FETCH_POSTS_KEY],
    queryFn: fetchPosts,
    staleTime: 3600 * 1000,
  })

  return postsQuery.data as PostData
}

export const useTopicNavigation = () => {
  const topicNavigationQuery = useQuery({
    queryKey: [FETCH_TOPIC_NAVIGATION_KEY],
    queryFn: fetchTopicNavigation,
    staleTime: 3600 * 1000,
  })

  return topicNavigationQuery.data as TopicNavigationData
}
